import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from '../components/ProtectedRoute';
import Layout from '../layouts/Layout';
import LoginForm from '../components/LoginForm';
import Dashboard from '../pages/Dashboard';
import Users from '../pages/Users';
import Events from '../pages/Events';
import Delegates from '../pages/Delegates';
import Visitors from '../pages/Visitors';
import GuestSpeakers from '../pages/GuestSpeakers';
import Roles from '../pages/Roles';
import Conference from '../pages/Conference';
import FloorPlan from '../pages/EscCalender';
import EscCalender from '../pages/EscCalender';
import Exhibitors from '../pages/Exhibitor/Exhibitors';
import ExhibitorDetailsPage from '../pages/Exhibitor/ExhibitorDetailsPage';
import FloorImage from '../pages/Floor/FloorImage';
import Guest from '../pages/Guest';
import NotificationsPage from '../pages/NotificationsPage';
import QueryList from '../pages/Query/QueryList';
import MeetingList from '../pages/Meetings';
import SendNotification from '../pages/sendNotification';

export default function AppRouter() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginForm />} />

      {/* Protected Routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/agenda" element={<Events />} />
                <Route path="/exhibitors" element={<Exhibitors />} />
                <Route
                  path="/exhibitors/:id"
                  element={<ExhibitorDetailsPage />}
                />
                <Route path="/delegates" element={<Delegates />} />
                <Route path="/visitors" element={<Visitors />} />
                <Route path="/speakers" element={<GuestSpeakers />} />
                {/* <Route path="/roles" element={<Roles />} /> */}
                <Route path="/conference" element={<Conference />} />
                <Route path="/esccalender" element={<EscCalender />} />
                <Route path="/floorimage" element={<FloorImage />} />
                <Route path="/guest" element={<Guest />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/query" element={<QueryList />} />
                <Route path="/meeting" element={<MeetingList />} />
                <Route
                  path="/sendnotification"
                  element={<SendNotification />}
                />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
